import { backendInstance } from './base'

export const CLUSTER_BASE_URL = 'clusters'

export type RectangleCoordsAPIType = {
  start_point_lat: number
  start_point_long: number
  end_point_lat: number
  end_point_long: number
}
export type ClusterType = {
  id: number
  sizeName: string
  coordinates: [number, number]
  titleSize: number
  circleWeight: number
  circleRadius: number
  targetOpacity: number
  pointsCount: number
  isSelected?: boolean
}

export type GetClustersPayload = {
  zoomLevel: number
  minLat: number
  minLon: number
  maxLat: number
  maxLon: number
  targetSize: string
  pageSize?: number
  amountThreshold?: number
  abortSignal?: AbortSignal
}

export type ClustersApiResponse = Array<ClusterType>
export type ClustersResponse = Array<ClusterType>

export const getClustersCall = async ({
  zoomLevel,
  minLat,
  minLon,
  maxLat,
  maxLon,
  targetSize,
  pageSize = 1600,
  amountThreshold = 250,
  abortSignal
}: GetClustersPayload): Promise<ClustersResponse> => {
  try {
    const response = await backendInstance.get<ClustersApiResponse>(
      `${CLUSTER_BASE_URL}/users/amount/prepared`,
      {
        params: {
          zoomLevel,
          targetSize,
          pageSize,
          amountThreshold,
          minLat,
          minLon,
          maxLat,
          maxLon
        },
        signal: abortSignal
      }
    )
    return response.data
  } catch (error: unknown) {
    return await Promise.reject(error)
  }
}
